import React from "react";

const ResumeDownload = ({ onDownload }) => {
  const handleDownload = () => {
    // Create a link element to download the existing PDF
    const link = document.createElement("a");
    link.href = "/nguyen-thanh-long-resume.pdf";
    link.download = "Nguyen_Thanh_Long_Resume.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Call the onDownload callback if provided
    if (onDownload) {
      onDownload();
    }
  };

  return (
    <button
      onClick={handleDownload}
      className="btn btn-accent"
      title="Download Resume PDF"
    >
      <i className="fas fa-download"></i> Download Resume
    </button>
  );
};

export default ResumeDownload;
